import React from 'react';
import { Input } from 'antd';

import { InputComponent } from 'components/common/form/Input';
import withTranslatePlaceholder from 'components/hocs/withTranslatePlaceholder';
import withFieldWrapper from 'components/hocs/withFieldWrapper';

@withTranslatePlaceholder
@withFieldWrapper
export default class TextComponent extends InputComponent {
    render() {
        const { className, meta, input, ...rest } = this.props;
        const classes = this.getInputClasses(className, meta);

        return (
            <Input.TextArea
                {...input}
                className={classes}
                autoSize={{ minRows: 2, maxRows: 10 }}
                {...rest}
            />
        );
    }
}
